export enum VipVerificationStatus {
  Pending,
  Approved,
  Rejected
}
